"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbRevertApply = exports._SbRevertApply = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _shapes = require("../../skybase-core/shapes");

var _sbButton = require("../sb-button/sb-button");

var _sbRevertApplyI18n = require("./sb-revert-apply-i18n");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NOOP = function NOOP() {};
/**
 * @namespace skybase-components.sb-revert-apply
 *
 * @public
 *
 * @class
 * @classdesc
 * Wrapper for revert-apply functionality.
 */
// eslint-disable-next-line no-underscore-dangle


var _SbRevertApply = /*#__PURE__*/function (_PureComponent) {
  _inherits(_SbRevertApply, _PureComponent);

  var _super = _createSuper(_SbRevertApply);

  function _SbRevertApply(props) {
    var _this;

    _classCallCheck(this, _SbRevertApply);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getContainerClassNames", function () {
      var _this$props = _this.props,
          bordered = _this$props.bordered,
          className = _this$props.className;
      return (0, _classnames.default)('sb-revert-apply', {
        bordered: bordered
      }, className);
    });

    _this.renderButtons = _this.renderButtons.bind(_assertThisInitialized(_this));
    _this.handleApplyClick = _this.handleApplyClick.bind(_assertThisInitialized(_this));
    _this.handleRevertClick = _this.handleRevertClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(_SbRevertApply, [{
    key: "handleApplyClick",
    value: function handleApplyClick() {
      var onApplyClick = this.props.onApplyClick;
      onApplyClick();
    }
  }, {
    key: "handleRevertClick",
    value: function handleRevertClick() {
      var onRevertClick = this.props.onRevertClick;
      onRevertClick();
    }
  }, {
    key: "renderButtons",
    value: function renderButtons() {
      var _this$props2 = this.props,
          values = _this$props2.values,
          cachedValues = _this$props2.cachedValues,
          applyButtonClassName = _this$props2.applyButtonClassName,
          applyButtonDisabled = _this$props2.applyButtonDisabled,
          applyButtonId = _this$props2.applyButtonId,
          buttonsPosition = _this$props2.buttonsPosition,
          revertButtonClassName = _this$props2.revertButtonClassName,
          revertButtonDisabled = _this$props2.revertButtonDisabled,
          revertButtonId = _this$props2.revertButtonId,
          _ = _this$props2.intl.formatMessage;
      var disabled = (0, _isEqual.default)(values, cachedValues);
      var classNames = (0, _classnames.default)('fl-container', 'fl-justify-sb', "sb-buttons-".concat(buttonsPosition));
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classNames
      }, /*#__PURE__*/_react.default.createElement(_sbButton.SbButton, {
        id: revertButtonId,
        onClick: this.handleRevertClick,
        disabled: disabled || revertButtonDisabled,
        className: (0, _classnames.default)('revert-button', revertButtonClassName)
      }, _(_sbRevertApplyI18n.messages.revert)), /*#__PURE__*/_react.default.createElement(_sbButton.SbButton, {
        id: applyButtonId,
        onClick: this.handleApplyClick,
        disabled: disabled || applyButtonDisabled,
        className: (0, _classnames.default)('apply-button', 'primary', applyButtonClassName)
      }, _(_sbRevertApplyI18n.messages.apply)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          id = _this$props3.id,
          buttonsPosition = _this$props3.buttonsPosition,
          children = _this$props3.children,
          style = _this$props3.style;
      var classNames = this.getContainerClassNames();
      var buttonsNode = this.renderButtons();
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classNames,
        id: id,
        style: style
      }, buttonsPosition === 'top' && buttonsNode, children, buttonsPosition !== 'top' && buttonsNode);
    }
  }]);

  return _SbRevertApply;
}(_react.PureComponent);

exports._SbRevertApply = _SbRevertApply;
_SbRevertApply.propTypes = {
  applyButtonDisabled: _propTypes.default.bool,
  revertButtonDisabled: _propTypes.default.bool,
  bordered: _propTypes.default.bool,
  // eslint-disable-line
  buttonsPosition: _propTypes.default.string,
  onApplyClick: _propTypes.default.func,
  onRevertClick: _propTypes.default.func,
  values: _propTypes.default.any,
  // eslint-disable-line
  cachedValues: _propTypes.default.any,
  // eslint-disable-line
  intl: _shapes.intlShape.isRequired,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  applyButtonClassName: _propTypes.default.string,
  revertButtonClassName: _propTypes.default.string,
  id: _propTypes.default.string,
  applyButtonId: _propTypes.default.string,
  revertButtonId: _propTypes.default.string,
  style: _propTypes.default.object // eslint-disable-line

};
_SbRevertApply.defaultProps = {
  applyButtonDisabled: false,
  revertButtonDisabled: false,
  bordered: true,
  buttonsPosition: 'top',
  onApplyClick: NOOP,
  onRevertClick: NOOP,
  values: null,
  cachedValues: null,
  children: null,
  className: null,
  applyButtonClassName: null,
  revertButtonClassName: null,
  id: null,
  applyButtonId: null,
  revertButtonId: null,
  style: null
};
var SbRevertApply = (0, _reactIntl.injectIntl)(_SbRevertApply);
exports.SbRevertApply = SbRevertApply;
//# sourceMappingURL=sb-revert-apply.js.map